import { render, staticRenderFns } from "./WebContentType.vue?vue&type=template&id=6f72420f&"
import script from "./WebContentType.vue?vue&type=script&lang=js&"
export * from "./WebContentType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports